import * as React from "react";
import { forwardRef } from "react";
const SvgBreadcrumbNavigateNext = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 5, height: 9, viewBox: "0 0 5 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0.5 8.5L4.5 4.5L0.5 0.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgBreadcrumbNavigateNext);
export { ForwardRef as ReactComponent };
